import { useEffect } from 'react'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { s_portal_webinar } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { ICON_SHARE_KAKAO } from '../../../modules/svg/svg'
import urls from '../../../modules/urls'
import { KAKAO_KEY } from '../../../modules/vars'
interface KakaoShareButtonType {
  id?: any
  title?: any
  description?: any
  webUrl?: any
  mobileWebUrl?: any
  imageUrl?: any
  width?: number
  children?: any
  className?: any
  customButtons?: any
  onClickHandler?: () => void
  callback?: () => void
}

const KakaoShareButton = ({
  id = 'kakao-link-btn',
  title = 'title',
  description = 'description',
  webUrl = urls.oneOnOne.index,
  mobileWebUrl = urls.oneOnOne.index,
  imageUrl = 'image',
  width = 47,
  children = null,
  className = null,
  customButtons = null,
  onClickHandler = null,
  callback = null,
}: KakaoShareButtonType) => {
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()
  const router = useAppRouter()
  let kakao = null
  if (typeof window !== 'undefined') {
    kakao = window?.Kakao
  }
  useEffect(() => {
    setTimeout(() => {
      createKakaoButton()
    }, 500)
  }, [kakao, title, description, imageUrl, webUrl, customButtons])

  const createKakaoButton = () => {
    // kakao sdk script이 정상적으로 불러와졌으면 window.Kakao로 접근이 가능합니다
    if (window.Kakao) {
      const kakao = window.Kakao

      // 중복 initialization 방지
      if (!kakao.isInitialized()) {
        // 두번째 step 에서 가져온 javascript key 를 이용하여 initialize
        kakao.init(KAKAO_KEY)
      }

      // 카카오 버튼 재생성 방지를 위한 체크
      const existingKakaoButton = document.querySelector(`#${id} .kakao-share-button`)
      if (existingKakaoButton) {
        return
      }

      kakao.Share.createDefaultButton({
        // Render 부분 id=kakao-link-btn 을 찾아 그부분에 렌더링을 합니다
        container: `#${id}`,
        objectType: 'feed',
        content: {
          title: title,
          description: description,
          imageUrl: imageUrl, // i.e. process.env.FETCH_URL + '/logo.png'
          link: {
            mobileWebUrl: webUrl,
            webUrl: webUrl,
          },
        },
        callback: () => (callback ? callback() : null),
        serverCallbackArgs: {
          userId: currentUser?.id,
          url: router.asPath,
        },
        buttons: customButtons
          ? customButtons
          : [
              {
                title: t(s_portal_webinar.register),
                link: {
                  mobileWebUrl: webUrl,
                  webUrl: webUrl,
                },
              },
            ],
      })
    }
  }

  const handleOnClick = () => {
    // console.info('click', id)
    onClickHandler ? onClickHandler() : null
  }

  return (
    <button id={id} className={className} onClick={() => handleOnClick()}>
      {children ? children : <img style={{ width }} src={ICON_SHARE_KAKAO} alt="kakao-share-icon" />}
    </button>
  )
}

export default KakaoShareButton
